import { Button, Checkbox, Col, Form, Input, notification, Popconfirm, Row, Spin, Switch, Table } from "antd";
import { EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { useEffect, useState } from "react";
import { addIngredientFormApi, listOfIngredientFormApi, updateIngredientFormApi } from "../../../../../config/Api";
import { API_ERR_MESSAGE, CHARACTER_PATTERN, CHARACTER_PATTERN_MESSAGE, NUMBER_AND_FRACTIONAL_PATTERN, NUMBER_AND_FRACTIONAL_PATTERN_MESSAGE } from "../../../../../config/constant";

export const IngredientsForm = () => {

    const [dataSource, setDataSource] = useState([]);
    const [displayData, setDisplayData] = useState([]);
    const [isActive, setIsActive] = useState(false)
    const [buttonName, setButtonName] = useState('ADD')
    const [IngredientFormData, setIngredientFormData] = useState()
    const [editIngredientFormRecord, setEditIngredientFormRecord] = useState()
    const [ingredients, setIngredients] = useState(false)
    const [loading, setLoading] = useState(false)

    // get the list of all available ingredients form
    //==============================
    const getlistOfIngredientForm = () => {
        setLoading(true)

        listOfIngredientFormApi()
            .then((res) => {
                if (res.status === 200) {
                    setDataSource(res.data.data);
                    setDisplayData(res.data.data);
                }
                setLoading(false)
            })
            .catch((err) => {
                notification.error({
                    message: 'something went wrong',
                });
            });
    }

    // call when user click on edit
    //==============================
    const editRecipeIngredientForm = (data) => {
        setButtonName("UPDATE")
        form.setFieldsValue({ 'name': data.name, "depriciation_percentage": data?.depriciation })
        setIngredients(data.type == 'ingredients' ? true : false)
        setEditIngredientFormRecord(data);
    }

    useEffect(() => {
        getlistOfIngredientForm()
    }, []);

    // filter data according to user search input 
    //==============================
    useEffect(() => {
        filterIngredientForm(IngredientFormData);
    }, []);

    // filter recipe ingredient Form
    //==============================
    const filterIngredientForm = (data) => {
        if (!data) {
            setDisplayData(dataSource);
        } else {
            let tmp = [];
            dataSource.length > 0 && dataSource.forEach((element) => {
                if (element.name.toUpperCase().indexOf(data.toUpperCase()) !== -1) {
                    tmp.push(element);
                }
            });
            setDisplayData(tmp);
        }
    };

    // update status of recipe ingredient form
    //==============================
    const onChange = (checked, data) => {
        let updatedData = data;
        updatedData.status = checked;

        updateIngredientFormApi(data.id, updatedData)
            .then((res) => {
                if (res.status == 200) {
                    notification.success({
                        message: "Ingredient Form Update successfully",
                    });
                    getlistOfIngredientForm()
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    };

    // handle submit
    //==============================
    const onFinish = (values) => {

        if (buttonName == 'ADD') {
            const data = {
                "name": values.name,
                "status": true,
                // if check box is checked then it is used in for ingredient page
                // so pass "ingredients" in db IN recipe section we display all ingredients forms   
                // "type": ingredients ? 'ingredients' : '',
                "depriciation": values.depriciation_percentage || 0,
                // "depreciate": false
            }
            addIngredientFormApi(data)
                .then((res) => {
                    if (res.status == 200) {
                        // form.setFieldsValue({ 'name': '' })
                        form.resetFields()
                        notification.success({
                            message: "Ingredient Form added successfully",
                        });
                        getlistOfIngredientForm()
                        setIngredients(false)

                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        }
        else {
            const data = {
                "name": values.name,
                // "type": ingredients ? 'ingredients' : '',
                "depriciation": values.depriciation_percentage || 0,
                "status": values.status
            }
            updateIngredientFormApi(editIngredientFormRecord.id, data)
                .then((res) => {
                    if (res.status == 200) {
                        setButtonName("ADD")
                        notification.success({
                            message: "Ingredient Form Update successfully",
                        });
                        getlistOfIngredientForm()
                        // form.setFieldsValue({ 'name': '' })
                        form.resetFields()
                        setIngredients(false)
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        }
    };

    const columns = [
        {
            title: 'name',
            dataIndex: 'name',
            key: 'name',
            render: (text) => <a>{text}</a>,
        },
        {
            title: 'Depriciation',
            dataIndex: 'depriciation',
            key: 'depriciation',
            render: (text) => <a>{text + "%"}</a>,
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (text, data) => <>
                <Switch checked={text} onChange={(e) => { setIsActive(!isActive); onChange(e, data) }} />
            </>,
            filters: [
                { text: "Active", value: true },
                { text: "DeActive", value: false },
            ],
            onFilter: (value, record) => record.status == value,
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <div className="action align-self-center">
                    <Button icon={<EditOutlined />} onClick={(e) => { setButtonName('UPDATE'); editRecipeIngredientForm(record) }} className="me-2" />                    {/* <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(record.key)}> */}
                    <Popconfirm title="Sure to delete?" >
                        <Button icon={<DeleteOutlined />} />
                    </Popconfirm>
                </div>
            ),
        },
    ];
    const data = [
        {
            id: '1',
            name: 'Grains',
            status: true
        },
        {
            id: '2',
            name: 'Protein',
            status: false
        },
        {
            id: '3',
            name: 'Cooked Vegetables',
            status: true
        },
        {
            id: '4',
            name: 'Fruits',
            status: true
        },
        {
            id: '5',
            name: 'Soup',
            status: true
        },
    ];

    const [form] = Form.useForm();

    const resetData = () => {
        form.resetFields()
    };
    return (
        <div className="IngredientsForm">
            <Row>
                <Col xl={14}>
                    <Form
                        name="IngredientsForm"
                        className="IngredientsFrom_Form"
                        form={form}
                        onFinish={onFinish}
                    >
                        <Row className="addIngredientsFrom_Form" gutter={[8, 8]}>
                            <Col xl={8}>

                                <Form.Item
                                    name="name"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please Enter Form Name!",
                                        },
                                        {
                                            pattern: CHARACTER_PATTERN,
                                            message: CHARACTER_PATTERN_MESSAGE,
                                        }
                                    ]}
                                >
                                    <Input placeholder="Enter Form Name" className="p-2" />
                                </Form.Item>
                            </Col>

                            <Col xl={8} className="d-flex">
                                <label className="form-input-label mb-0 align-self-center">
                                    Depriciation
                                </label>
                                <Form.Item
                                    name="depriciation_percentage"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Enter Depriciation Percentage!",
                                        },
                                        {
                                            pattern: NUMBER_AND_FRACTIONAL_PATTERN,
                                            message: NUMBER_AND_FRACTIONAL_PATTERN_MESSAGE,
                                        }
                                    ]}
                                    initialValue="0"
                                >
                                    <Input placeholder="Depriciation (%)" className="ms-1 p-2" />
                                </Form.Item>
                            </Col>
                            {/* <Col xl={4}>
                                <Form.Item
                                    name="ingredients"
                                >
                                    <Checkbox checked={ingredients} onChange={(e) => setIngredients(e.target.checked)} className="p-2" />
                                    <b>For Ingredient</b>
                                </Form.Item>
                            </Col> */}

                            <Col xl={8}>
                                <Button htmlType="submit" className="submit-button  border-0 rounded ms-2"
                                    icon={buttonName == 'ADD' ? <PlusOutlined style={{ fontSize: "1.2rem" }} /> : <EditOutlined style={{ fontSize: "1rem" }} />}  >
                                    {buttonName}
                                </Button>
                            </Col>
                        </Row>

                    </Form>

                </Col>
                <Col xl={4} className="text-end align-self-center">
                    <h6>Total Ingredients Form: {displayData.length > 0 ? displayData.length : 0} </h6>
                </Col>
                <Col xl={6} className="align-self-center">
                    <Input.Search placeholder="Search Ingredients Form"
                        onChange={(e) => { filterIngredientForm(e.target.value); setIngredientFormData(e.target.value) }}
                        className="p-2" />
                </Col>
            </Row>

            <Spin spinning={loading} className="spinner-code">
                <Row>
                    <Table
                        columns={columns}
                        rowKey="id"
                        dataSource={displayData}
                        // pagination={false}
                        scroll={{ x: "max-content" }}
                        className="w-100"
                    />
                </Row>
            </Spin>
        </div>
    )
}
